import { Loader2 } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import LogoutIcon from '@/assets/icons/logout.svg';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';
import { useOpeningDetails } from '@/contexts/opening-context';

interface HeaderProps {
  isFormDirty: boolean;
  isSaving: boolean;
  onQuit: () => void;
}

export function Header({ isFormDirty, isSaving, onQuit }: HeaderProps) {
  const { opening } = useOpeningDetails();
  const { campaign, isCompleted } = useEditCampaignContext();
  const isReadonly = campaign?.is_readonly;

  return (
    <div className="flex items-center justify-between bg-white p-2">
      <div className="flex items-center gap-4">
        <Button variant="secondary" type="button" onClick={onQuit}>
          <img src={LogoutIcon} alt="" />
          <FormattedMessage
            defaultMessage="Quit"
            description="Close Reach campaign editor without saving (if allowed)"
          />
        </Button>
        <Typography variant="body1">{opening.title}</Typography>
      </div>

      {!isCompleted && !isReadonly && (
        <Button type="submit" disabled={!isFormDirty || isSaving}>
          {isSaving && <Loader2 className="animate-spin" />}
          <FormattedMessage
            defaultMessage="Update campaign"
            description="Save Reach multi-publisher campaign from the top bar"
          />
        </Button>
      )}
    </div>
  );
}
